import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FormTextInput from './form_text_input.jsx';
import FormTextAreaInput from './form_text_area_input.jsx';
import FormCheckboxInput from './form_checkbox_input.jsx';
import FormRadioInput from './form_radio_input.jsx';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import { questionPropType } from './prop_types.js';
import {
  FIELD_TYPE_SHORT_ANSWER,
  FIELD_TYPE_LONG_ANSWER,
  FIELD_TYPE_SINGLE_ANSWER,
  FIELD_TYPE_MULTI_ANSWER
} from 'zoomforth_zf/models/form.js';

export const FormInput_ViewerVersion2 = (props) => {
  const {
    question,
    formValue
  } = props;

  return (
    <div id={question.href} className={classnames(
      'form-input-container',
      `form-input-type-${question.type}`,
      formValue.error ? 'form-input-has-error' : formValue.isTouched ? 'form-input-is-valid' : 'form-input-is-untouched',
      question.isRequired ? 'form-input-is-required' : 'form-input-is-optional'
    )}>
      {
        question.type == FIELD_TYPE_SHORT_ANSWER ?
          <FormTextInput {...props} />
          : question.type == FIELD_TYPE_LONG_ANSWER ?
            <FormTextAreaInput {...props} />
            : question.type == FIELD_TYPE_MULTI_ANSWER ?
              <FormCheckboxInput {...props} />
              : question.type == FIELD_TYPE_SINGLE_ANSWER ?
                <FormRadioInput {...props} />
                :
                null
      }
    </div>
  );
};

FormInput_ViewerVersion2.propTypes = {
  question: questionPropType.isRequired
};

export const FormInput_ViewerVersion1 = ({
  question,
  ...props
}) => (
  question.type == FIELD_TYPE_SHORT_ANSWER ?
    <FormTextInput question={question} {...props} />
    : question.type == FIELD_TYPE_LONG_ANSWER ?
      <FormTextAreaInput question={question} {...props} />
      : question.type == FIELD_TYPE_MULTI_ANSWER ?
        <FormCheckboxInput question={question} {...props} />
        : question.type == FIELD_TYPE_SINGLE_ANSWER ?
          <FormRadioInput question={question} {...props} />
          :
          null
);

FormInput_ViewerVersion1.propTypes = {
  question: questionPropType.isRequired
};

const FormInput = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormInput_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormInput_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormInput;